import { render } from "./KonvaViewer.vue?vue&type=template&id=0060a502&scoped=true"
import script from "./KonvaViewer.vue?vue&type=script&lang=js"
export * from "./KonvaViewer.vue?vue&type=script&lang=js"

import "./KonvaViewer.vue?vue&type=style&index=0&id=0060a502&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0060a502"]])

export default __exports__